(function () {
  'use strict';

  // Variant we want selected, captured before MoonBundle can rewrite the URL.
  var wantedRaw = new URLSearchParams(location.search).get('variant');
  if (!wantedRaw) return; // nothing to enforce here

  // Compare ids by numeric part so "gid://…/123" and "123" match.
  function idOf(x) {
    var m = String(x == null ? '' : x).match(/\d+/g);
    return m ? m[m.length - 1] : '';
  }
  var wanted = idOf(wantedRaw);

  // 1. Put our variant first so MoonBundle's default resolver picks it.
  function reorder(props) {
    var p = props && props.mainProduct;
    if (!p || !Array.isArray(p.variants)) return false;
    var i = p.variants.findIndex(function (v) { return idOf(v.id) === wanted; });
    if (i < 0) return false;                 // not this product
    if (i > 0) p.variants.unshift(p.variants.splice(i, 1)[0]);
    return true;
  }

  // 2. URL pin — armed only after MoonBundle is confirmed present.
  var pinArmed = false;
  function armPin() {
    if (pinArmed) return;
    pinArmed = true;

    var released = false;
    var SELECTORS = [
      '.moonbundle-dropdown-button', '.moonbundle-custom-dropdown', '[role="option"]',
      '.moonbundle-swatch-option-value', '.moonbundle-swatch-buttons',
      'select[name="id"]', '[name="id"]', 'variant-selects', 'variant-radios', 'product-variants'
    ].join(',');
    var EVENTS = ['pointerdown', 'touchstart', 'mousedown', 'click', 'change'];

    // Release on the first genuine interaction with a variant control,
    // so the pin never overrides a real variant change by the shopper.
    function release(e) {
      if (!e.isTrusted) return;
      if (e.target && e.target.closest && e.target.closest(SELECTORS)) {
        released = true;
        EVENTS.forEach(function (ev) { document.removeEventListener(ev, release, true); });
      }
    }
    EVENTS.forEach(function (ev) { document.addEventListener(ev, release, true); });

    // While pinned, rewrite any attempt to set a different variant back to ours.
    function guard(orig) {
      return function (state, title, url) {
        try {
          if (!released && url != null) {
            var u = new URL(url, location.href);
            var v = u.searchParams.get('variant');
            if (v && idOf(v) !== wanted) {
              u.searchParams.set('variant', wantedRaw);
              return orig.call(this, state, title, u.pathname + u.search + u.hash);
            }
          }
        } catch (_) {}
        return orig.apply(this, arguments);
      };
    }
    history.replaceState = guard(history.replaceState);
    history.pushState = guard(history.pushState);
  }

  // 3. Wrap MoonBundle's factory so we run just before it mounts.
  function wrap(factory) {
    if (typeof factory !== 'function' || factory.__mbVariantFix) return factory;
    function wrapped(opts) {
      try { if (reorder(opts && opts.props)) armPin(); } catch (_) {}
      return factory.apply(this, arguments);
    }
    wrapped.__mbVariantFix = true;
    try { Object.keys(factory).forEach(function (k) { wrapped[k] = factory[k]; }); } catch (_) {}
    return wrapped;
  }

  if (typeof window.MoonBundle === 'function') {
    window.MoonBundle = wrap(window.MoonBundle);
  } else {
    try {
      var held;
      Object.defineProperty(window, 'MoonBundle', {
        configurable: true,
        get: function () { return held; },
        set: function (v) { held = wrap(v); }
      });
    } catch (_) {
      // Fallback if MoonBundle is already a non-configurable global.
      var t0 = Date.now();
      var poll = setInterval(function () {
        if (typeof window.MoonBundle === 'function' && !window.MoonBundle.__mbVariantFix) {
          window.MoonBundle = wrap(window.MoonBundle);
          clearInterval(poll);
        } else if (Date.now() - t0 > 10000) clearInterval(poll);
      }, 10);
    }
  }
})();